export default __webpack_public_path__ + "static/top_view-273a71b7bc4943c8b305b9873897ea82.jpg";